<template>

    <div class="flex flex-col dark:text-white mb-5">
        <div class="mb-6">
            <div class="flex items-center justify-between">
                <div>
                    <h2 class="text-2xl font-bold text-gray-900 dark:text-white">
                        Detalhes do Membro - {{ userData?.name || userData?.email || 'Carregando...' }}
                    </h2>
                    <p class="text-gray-600 dark:text-gray-400">
                        Configure permissões e visualize histórico de convites
                    </p>
                </div>
                <button
                    @click="$router.push({ name: 'auditoria.mozart.invite-members' })"
                    class="inline-flex items-center px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 dark:hover:bg-gray-700"
                >
                    ← Voltar
                </button>
            </div>
        </div>

        <div class="space-y-6">
            <div class="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
                <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-4">
                    Configurações do Portal Manual Access Control
                </h3>

                <form @submit.prevent="updatePortalConfig" class="space-y-4">
                    <div class="grid grid-cols-2 gap-4 p-4 bg-gray-50 dark:bg-gray-700 rounded-md">
                        <div>
                            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                                Nome
                            </label>
                            <p class="text-sm text-gray-900 dark:text-white">{{ userData?.name || '-' }}</p>
                        </div>
                        <div>
                            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                                Email
                            </label>
                            <p class="text-sm text-gray-900 dark:text-white">{{ userData?.email || '-' }}</p>
                        </div>
                    </div>

                    <div>
                        <label class="inline-flex cursor-pointer items-center">
                            <input
                                v-model="configForm.is_enabled"
                                type="checkbox"
                                class="sr-only"
                            />
                            <div
                                :class="{
                                    'bg-indigo-500': configForm.is_enabled,
                                    'bg-gray-400': !configForm.is_enabled,
                                }"
                                class="relative flex h-6 w-10 items-center rounded-full transition duration-200 ease-in-out"
                            >
                                <span
                                    :class="{
                                        'translate-x-4': configForm.is_enabled,
                                        'translate-x-0': !configForm.is_enabled,
                                    }"
                                    class="mx-0.5 my-auto inline-block h-4 w-4 transform rounded-full bg-white transition duration-200 ease-in-out"
                                ></span>
                            </div>
                            <span class="ml-3 text-sm font-medium text-gray-700 dark:text-gray-300">
                                {{ configForm.is_enabled ? 'Habilitado' : 'Desabilitado' }}
                            </span>
                        </label>
                        <div class="mt-1">
                            <small class="text-gray-500 dark:text-gray-400">
                                Habilitar ou desabilitar o convite manual
                            </small>
                        </div>
                    </div>

                    <div>
                        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                            Vendas Mínimas Requeridas
                        </label>
                        <small class="text-gray-500 dark:text-gray-400">
                            Quantas vendas o usuário precisa fazer para poder realizar invites manualmente (o valor abaixo + 1 venda)
                        </small>
                        <input
                            v-model.number="configForm.min_sales_required"
                            type="number"
                            min="0"
                            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                            placeholder="10"
                        />
                    </div>

                    <div>
                        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                            Período de Vendas (dias)
                        </label>
                        <small class="text-gray-500 dark:text-gray-400">
                            Período de tempo para contar as vendas
                        </small>
                        <input
                            v-model.number="configForm.sales_period_days"
                            type="number"
                            min="1"
                            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                            placeholder="360"
                        />
                    </div>

                    <div>
                        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                            Vendas por Acesso Manual
                        </label>
                        <small class="text-gray-500 dark:text-gray-400">
                            Quantas vendas o usuário precisa fazer para poder realizar invites manualmente
                        </small>
                        <input
                            v-model.number="configForm.sales_per_manual_access"
                            type="number"
                            min="1"
                            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                            placeholder="1"
                        />
                    </div>

                    <div>
                        <div v-if="configForm.under_migration && configForm.migration_period_ends_at" class="mt-5">
                            <div class="p-4 bg-green-50 dark:bg-green-900/20 border-l-4 border-green-500 rounded-r-lg">
                                <div class="flex items-start">
                                    <svg class="w-5 h-5 text-green-500 mt-0.5 mr-3 shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                        <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
                                    </svg>
                                    <div class="flex-1">
                                        <p class="text-sm font-semibold text-green-800 dark:text-green-200">
                                            ✅ Liberação Temporária Ativa
                                        </p>
                                        <p class="text-lg font-bold text-green-900 dark:text-green-100 mt-2">
                                            Convites Manuais Liberados até {{ formatMigrationDate() }}
                                        </p>
                                        <p class="text-sm text-green-700 dark:text-green-300 mt-2">
                                            O usuário <strong>PODERÁ</strong> realizar invites manuais até esta data. Após o período, passará a valer a configuração padrão de invites manuais.
                                        </p>
                                        <div class="mt-4 pt-3 border-t border-green-200 dark:border-green-800">
                                            <div class="flex items-start mb-3">
                                                <svg class="w-4 h-4 text-green-600 dark:text-green-400 mt-0.5 mr-2 shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                                    <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"/>
                                                </svg>
                                                <div>
                                                    <p class="text-xs font-medium text-green-700 dark:text-green-300">
                                                        Para editar o período de liberação:
                                                    </p>
                                                    <p class="text-xs text-green-600 dark:text-green-400 mt-1">
                                                        1. Desative o toggle abaixo<br>
                                                        2. Clique em "Salvar Configurações"<br>
                                                        3. Configure o novo período
                                                    </p>
                                                </div>
                                            </div>
                                            <label class="inline-flex cursor-pointer items-center">
                                                <input
                                                    v-model="configForm.under_migration"
                                                    type="checkbox"
                                                    class="sr-only"
                                                />
                                                <div
                                                    :class="{
                                                        'bg-amber-500': configForm.under_migration,
                                                        'bg-gray-400': !configForm.under_migration,
                                                    }"
                                                    class="relative flex h-6 w-10 items-center rounded-full transition duration-200 ease-in-out"
                                                >
                                                    <span
                                                        :class="{
                                                            'translate-x-4': configForm.under_migration,
                                                            'translate-x-0': !configForm.under_migration,
                                                        }"
                                                        class="mx-0.5 my-auto inline-block h-4 w-4 transform rounded-full bg-white transition duration-200 ease-in-out"
                                                    ></span>
                                                </div>
                                                <span class="ml-3 text-sm font-medium text-green-800 dark:text-green-200">
                                                    {{ configForm.under_migration ? 'Clique para desativar período de migração' : 'Período desativado - Salve para confirmar' }}
                                                </span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-else>
                            <div class="mt-5">
                                <h3 class="text-lg font-medium text-gray-900 dark:text-white">
                                    Usuário em Período de Migração
                                </h3>
                                <p class="text-sm text-gray-600 dark:text-gray-400 mt-1">
                                    Usuários em migração estão bloqueados por padrão. Ative esta opção para conceder uma liberação temporária de invites manuais.
                                </p>
                            </div>
                            <label class="inline-flex cursor-pointer items-center mt-2">
                                <input
                                    v-model="configForm.under_migration"
                                    type="checkbox"
                                    class="sr-only"
                                />
                                <div
                                    :class="{
                                        'bg-amber-500': configForm.under_migration,
                                        'bg-gray-400': !configForm.under_migration,
                                    }"
                                    class="relative flex h-6 w-10 items-center rounded-full transition duration-200 ease-in-out"
                                >
                                    <span
                                        :class="{
                                            'translate-x-4': configForm.under_migration,
                                            'translate-x-0': !configForm.under_migration,
                                        }"
                                        class="mx-0.5 my-auto inline-block h-4 w-4 transform rounded-full bg-white transition duration-200 ease-in-out"
                                    ></span>
                                </div>
                                <span class="ml-3 text-sm font-medium text-gray-700 dark:text-gray-300">
                                    {{ configForm.under_migration ? 'Em Migração (configure liberação abaixo)' : 'Não está em migração' }}
                                </span>
                            </label>
                            <div v-if="configForm.under_migration" class="mt-5">
                                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                                    Por quantos dias liberar invites manuais?
                                </label>
                                <small class="text-gray-500 dark:text-gray-400 block mb-2">
                                    Conceda uma liberação temporária a partir de hoje para que o usuário possa realizar invites manuais
                                </small>
                                <select
                                    v-model="configForm.under_migration_days"
                                    class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                                >
                                    <option value="" disabled selected>Selecione o período de liberação</option>
                                    <option value="15">Liberar por 15 dias</option>
                                    <option value="30">Liberar por 30 dias</option>
                                    <option value="45">Liberar por 45 dias</option>
                                    <option value="60">Liberar por 60 dias</option>
                                </select>

                                <div v-if="configForm.under_migration_days" class="mt-4 p-4 bg-green-50 dark:bg-green-900/20 border-l-4 border-green-500 rounded-r-lg">
                                    <div class="flex items-start">
                                        <svg class="w-5 h-5 text-green-500 mt-0.5 mr-3 shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                            <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
                                        </svg>
                                        <div class="flex-1">
                                            <p class="text-sm font-semibold text-green-800 dark:text-green-200">
                                                Invites Manuais Liberados até
                                            </p>
                                        <p class="text-lg font-bold text-green-900 dark:text-green-100 mt-1">
                                            {{ formatMigrationDate() }}
                                        </p>
                                            <p class="text-sm text-green-700 dark:text-green-300 mt-1">
                                                O usuário <strong>PODERÁ</strong> realizar invites manuais. Após esta data, a liberação temporária expira e passará a valer a configuração de invites manuais.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="flex justify-end space-x-3 pt-4 border-t border-gray-200 dark:border-gray-700">
                        <div class="flex-1 flex items-center">
                            <svg class="w-4 h-4 text-amber-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                                <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"/>
                            </svg>
                            <span class="text-sm text-gray-600 dark:text-gray-400">
                                Clique em "Salvar" para aplicar as alterações
                            </span>
                        </div>
                        <button
                            type="submit"
                            :disabled="configLoading"
                            class="px-6 py-2 text-sm font-medium text-white bg-blue-500 rounded-md hover:bg-blue-600 disabled:opacity-50 transition-colors"
                        >
                            {{ configLoading ? 'Salvando...' : 'Salvar Configurações' }}
                        </button>
                    </div>
                </form>
            </div>

            <div v-if="userSettings && userSettings.histories && userSettings.histories.length > 0" class="bg-white dark:bg-gray-800 rounded-lg shadow">
                <button
                    @click="historyCollapsed = !historyCollapsed"
                    class="w-full flex items-center justify-between p-6 text-left hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
                >
                    <h3 class="text-lg font-semibold text-gray-900 dark:text-white">
                        Histórico de Alterações
                        <span class="ml-2 text-sm font-normal text-gray-500 dark:text-gray-400">
                            ({{ userSettings.histories.length }} registro{{ userSettings.histories.length !== 1 ? 's' : '' }})
                        </span>
                    </h3>
                    <svg
                        :class="{ 'rotate-180': !historyCollapsed }"
                        class="w-5 h-5 text-gray-500 transition-transform duration-200"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                    >
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                    </svg>
                </button>

                <div v-show="!historyCollapsed" class="border-t border-gray-200 dark:border-gray-700">
                    <div class="p-6 space-y-4 max-h-96 overflow-y-auto">
                        <div
                            v-for="(history, index) in userSettings.histories"
                            :key="history.id"
                            class="relative pl-8 pb-6 last:pb-0"
                        >
                            <div
                                v-if="index < userSettings.histories.length - 1"
                                class="absolute left-2 top-6 bottom-0 w-0.5 bg-gray-200 dark:bg-gray-700"
                            ></div>

                            <div class="absolute left-0 top-1 w-4 h-4 rounded-full bg-blue-500 border-2 border-white dark:border-gray-800"></div>

                            <div class="bg-gray-50 dark:bg-gray-700 rounded-lg p-4">
                                <div class="flex items-start justify-between mb-3">
                                    <div class="flex items-center space-x-2">
                                        <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                        </svg>
                                        <div>
                                            <p class="text-sm font-semibold text-gray-900 dark:text-white">
                                                {{ history.causer?.name || 'Sistema' }}
                                            </p>
                                            <p class="text-xs text-gray-500 dark:text-gray-400">
                                                {{ history.causer?.email || '-' }}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="text-right">
                                        <p class="text-xs text-gray-500 dark:text-gray-400">
                                            {{ history.created_at }}
                                        </p>
                                    </div>
                                </div>

                                <div class="grid grid-cols-2 gap-3 mt-3 pt-3 border-t border-gray-200 dark:border-gray-600">
                                    <div class="text-sm">
                                        <span class="text-gray-600 dark:text-gray-400">Habilitado:</span>
                                        <span class="ml-1 font-medium text-gray-900 dark:text-white">{{ history.is_enabled ? 'Sim' : 'Não' }}</span>
                                    </div>
                                    <div class="text-sm">
                                        <span class="text-gray-600 dark:text-gray-400">Vendas Mínimas:</span>
                                        <span class="ml-1 font-medium text-gray-900 dark:text-white">{{ history.min_sales_required }}</span>
                                    </div>
                                    <div class="text-sm">
                                        <span class="text-gray-600 dark:text-gray-400">Período (dias):</span>
                                        <span class="ml-1 font-medium text-gray-900 dark:text-white">{{ history.sales_period_days }}</span>
                                    </div>
                                    <div class="text-sm">
                                        <span class="text-gray-600 dark:text-gray-400">Vendas por Acesso:</span>
                                        <span class="ml-1 font-medium text-gray-900 dark:text-white">{{ history.sales_per_manual_access }}</span>
                                    </div>
                                    <div class="text-sm col-span-2">
                                        <span class="text-gray-600 dark:text-gray-400">Período de Migração:</span>
                                        <span class="ml-1 font-medium text-gray-900 dark:text-white">
                                            {{ history.migration_period_ends_at || '-' }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
                <div class="flex items-center justify-between mb-4">
                    <h3 class="text-lg font-medium text-gray-900 dark:text-white">
                        Validação de Acesso Manual
                    </h3>
                    <button
                        @click="fetchValidation"
                        :disabled="validationLoading"
                        class="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-md disabled:opacity-50"
                    >
                        <span v-if="validationLoading">Carregando...</span>
                        <span v-else>Atualizar</span>
                    </button>
                </div>

                <div v-if="configForm.under_migration" class="mb-4 p-4 bg-amber-50 dark:bg-amber-900/20 border-l-4 border-amber-500 rounded-r-lg">
                    <div class="flex items-start">
                        <svg class="w-5 h-5 text-amber-500 mt-0.5 mr-3 shrink-0" fill="currentColor" viewBox="0 0 20 20">
                            <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd"/>
                        </svg>
                        <div class="flex-1">
                            <p class="text-sm font-semibold text-amber-800 dark:text-amber-200 mb-1">
                                ⚠️ Usuário em Período de Migração
                            </p>
                            <p class="text-sm text-amber-700 dark:text-amber-300">
                                <span v-if="configForm.migration_period_ends_at">
                                    Este usuário possui uma <strong>liberação temporária</strong> para realizar invites manuais até <strong>{{ formatMigrationDate() }}</strong>.
                                </span>
                                <span v-else>
                                    Este usuário está em período de migração, mas <strong>não possui liberação temporária configurada</strong>. Configure os dias de liberação acima para permitir invites manuais.
                                </span>
                            </p>
                        </div>
                    </div>
                </div>

                <div v-if="validationLoading" class="space-y-4">
                    <div v-for="n in 3" :key="n" class="h-4 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></div>
                </div>

                <div v-else-if="validation" class="space-y-4">
                    <div class="p-4 rounded-lg border" :class="validation.allow_manual_access ? 'bg-green-50 border-green-200 dark:bg-green-900/20 dark:border-green-800' : 'bg-red-50 border-red-200 dark:bg-red-900/20 dark:border-red-800'">
                        <div class="flex items-center space-x-2">
                            <div class="w-3 h-3 rounded-full" :class="validation.allow_manual_access ? 'bg-green-500' : 'bg-red-500'"></div>
                            <span class="font-medium" :class="validation.allow_manual_access ? 'text-green-800 dark:text-green-200' : 'text-red-800 dark:text-red-200'">
                                {{ validation.allow_manual_access ? 'Invite Manual Permitido' : 'Invite Manual Desabilitado' }}
                            </span>
                        </div>
                        <p class="mt-2 text-sm" :class="validation.allow_manual_access ? 'text-green-700 dark:text-green-300' : 'text-red-700 dark:text-red-300'">
                            {{ validation.reason }}
                        </p>
                    </div>

                    <div v-if="validation.sales_count !== undefined" class="grid grid-cols-2 md:grid-cols-4 gap-4">
                        <div class="bg-gray-50 dark:bg-gray-700 p-3 rounded-lg">
                            <div class="text-sm text-gray-600 dark:text-gray-400">Vendas no Período</div>
                            <div class="text-lg font-semibold text-gray-900 dark:text-white">{{ validation.sales_count || 0 }}</div>
                        </div>

                        <div v-if="validation.min_required !== undefined" class="bg-gray-50 dark:bg-gray-700 p-3 rounded-lg">
                            <div class="text-sm text-gray-600 dark:text-gray-400">Mínimo Exigido</div>
                            <div class="text-lg font-semibold text-gray-900 dark:text-white">{{ validation.min_required }}</div>
                        </div>

                        <div v-if="validation.manual_accesses_count !== undefined" class="bg-gray-50 dark:bg-gray-700 p-3 rounded-lg">
                            <div class="text-sm text-gray-600 dark:text-gray-400">Acessos Utilizados</div>
                            <div class="text-lg font-semibold text-gray-900 dark:text-white">{{ validation.manual_accesses_count }}</div>
                        </div>

                        <div v-if="validation.allowed_manual_accesses !== undefined" class="bg-gray-50 dark:bg-gray-700 p-3 rounded-lg">
                            <div class="text-sm text-gray-600 dark:text-gray-400">Acessos Permitidos</div>
                            <div class="text-lg font-semibold text-gray-900 dark:text-white">{{ validation.allowed_manual_accesses }}</div>
                        </div>

                        <div v-if="validation.remaining_accesses !== undefined" class="bg-gray-50 dark:bg-gray-700 p-3 rounded-lg">
                            <div class="text-sm text-gray-600 dark:text-gray-400">Acessos Restantes</div>
                            <div class="text-lg font-semibold text-green-600 dark:text-green-400">{{ validation.remaining_accesses }}</div>
                        </div>

                        <div v-if="validation.sales_per_manual_access !== undefined" class="bg-gray-50 dark:bg-gray-700 p-3 rounded-lg">
                            <div class="text-sm text-gray-600 dark:text-gray-400">Vendas por Acesso</div>
                            <div class="text-lg font-semibold text-gray-900 dark:text-white">{{ validation.sales_per_manual_access }}</div>
                        </div>

                        <div v-if="validation.period_days !== undefined" class="bg-gray-50 dark:bg-gray-700 p-3 rounded-lg">
                            <div class="text-sm text-gray-600 dark:text-gray-400">Período (dias)</div>
                            <div class="text-lg font-semibold text-gray-900 dark:text-white">{{ validation.period_days }}</div>
                        </div>
                    </div>
                </div>

                <div v-else class="text-center text-gray-500 dark:text-gray-400 py-8">
                    Nenhuma informação de validação disponível
                </div>
            </div>

            <div class="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
                <div class="flex items-center justify-between mb-4">
                    <h3 class="text-lg font-semibold text-gray-900 dark:text-white">
                        Pessoas Convidadas pelo Produtor
                    </h3>
                </div>

                <div class="overflow-x-auto">
                    <table class="w-full table-auto border-collapse text-sm">
                        <thead>
                            <tr class="bg-gray-50 dark:bg-gray-700">
                                <th class="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">ID</th>
                                <th class="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Portal</th>
                                <th class="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Usuário</th>
                                <th class="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Email</th>
                                <th class="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Tipo</th>
                                <th class="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Dias de Acesso</th>
                                <th class="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Expira em</th>
                                <th class="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Criado em</th>
                            </tr>
                        </thead>
                        <tbody class="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">
                            <template v-if="invitesLoading">
                                <tr v-for="n in 5" :key="'loading-' + n">
                                    <td v-for="col in 8" :key="'col-' + col" class="px-3 py-2">
                                        <div class="h-4 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></div>
                                    </td>
                                </tr>
                            </template>
                            <tr v-else-if="invites.length === 0">
                                <td colspan="8" class="px-3 py-8 text-center text-gray-500 dark:text-gray-400">
                                    Nenhum convite encontrado
                                </td>
                            </tr>
                            <tr v-else v-for="invite in invites" :key="invite.id" class="hover:bg-gray-50 dark:hover:bg-gray-700">
                                <td class="px-3 py-2 text-sm text-gray-900 dark:text-white">{{ invite.id || '-' }}</td>
                                <td class="px-3 py-2 text-sm text-gray-900 dark:text-white">{{ invite.portal?.name || '-' }}</td>
                                <td class="px-3 py-2 text-sm text-gray-900 dark:text-white">{{ invite.user?.name || '-' }}</td>
                                <td class="px-3 py-2 text-sm text-gray-500 dark:text-gray-400">{{ invite.user?.email || '-' }}</td>
                                <td class="px-3 py-2 text-sm text-gray-900 dark:text-white">
                                    <span class="px-2 py-1 text-xs rounded-full" :class="getTypeClass(invite.type)">
                                        {{ getTypeLabel(invite.type) }}
                                    </span>
                                </td>
                                <td class="px-3 py-2 text-sm text-gray-900 dark:text-white">{{ invite.days_of_access || '-' }}</td>
                                <td class="px-3 py-2 text-sm text-gray-500 dark:text-gray-400">{{ formatDate(invite.expires_at) || '-' }}</td>
                                <td class="px-3 py-2 text-sm text-gray-500 dark:text-gray-400">{{ formatDate(invite.created_at) || '-' }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { useToast } from "vue-toastification";
import Pagination from "../../components/layouts/Pagination.vue";
import { parseBrazilianDate } from "../../utils/dateHelpers";

export default {
    components: { Pagination },
    setup() {
        const toast = useToast();
        return { toast };
    },
    data() {
        return {
            configLoading: false,
            invitesLoading: false,
            validationLoading: false,
            historyCollapsed: true,
            memberData: {},
            userData: null,
            userSettings: null,
            validation: null,
            configForm: {
                min_sales_required: 0,
                sales_period_days: 0,
                sales_per_manual_access: 0,
                is_enabled: false,
                under_migration: false,
                under_migration_days: '',
                migration_period_ends_at: null
            },
            invites: [],
        };
    },

    mounted() {
        this.fetchUserSetting();
        this.fetchValidation();
        this.fetchInvites();
    },

    watch: {
        'configForm.under_migration'(newValue) {
            if (!newValue) {
                this.configForm.migration_period_ends_at = null;
                this.configForm.under_migration_days = '';
            }
        }
    },

    methods: {
        async fetchUserSetting() {
            try {
                const { data } = await axios.get(`/api/auditoria/invite-members/${this.$route.params.user}`);

                this.userData = data.user;
                this.userSettings = data;

                this.configForm = {
                    min_sales_required: data.min_sales_required || 0,
                    sales_period_days: data.sales_period_days || 0,
                    sales_per_manual_access: data.sales_per_manual_access || 0,
                    is_enabled: !!data.is_enabled,
                    under_migration: !!data.migration_period_ends_at,
                    under_migration_days: '',
                    migration_period_ends_at: data.migration_period_ends_at || null
                };

            } catch (error) {
                this.toast.error('Erro ao carregar dados');
            }
        },

        async fetchInvites() {
            this.invitesLoading = true;

            try {
                const { data } = await axios.get(`/api/auditoria/invite-members/${this.$route.params.user}/invites`);
                this.invites = data;

            } catch (error) {
                this.toast.error('Erro ao carregar convites');
            } finally {
                this.invitesLoading = false;
            }
        },

        async updatePortalConfig() {
            this.configLoading = true;

            try {
                const { data } = await axios.put(`/api/auditoria/invite-members/${this.$route.params.user}`, this.configForm);
                this.toast.success(data.message || 'Configurações do portal atualizadas com sucesso!');
                this.fetchUserSetting();
                await this.fetchValidation();
            } catch (error) {
                this.toast.error(error.response?.data?.message || 'Erro ao atualizar configurações do portal');
            } finally {
                this.configLoading = false;
            }
        },

        async fetchValidation() {
            this.validationLoading = true;

            try {
                const { data } = await axios.get(`/api/auditoria/invite-members/${this.$route.params.user}/validation`);
                this.validation = data;
            } catch (error) {
                this.toast.error('Erro ao carregar validação');
            } finally {
                this.validationLoading = false;
            }
        },

        formatDate(dateString) {
            if (!dateString) return '-';

            const parsedDate = parseBrazilianDate(dateString);
            if (!parsedDate) return '-';

            return parsedDate.toLocaleDateString('pt-BR', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            });
        },

        getTypeLabel(type) {
            const types = {
                'common': 'Comum',
                'lifetime': 'Vitalício',
                'trial': 'Trial',
                'premium': 'Premium'
            };
            return types[type] || type || '-';
        },

        getTypeClass(type) {
            const classes = {
                'common': 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200',
                'lifetime': 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200',
                'trial': 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200',
                'premium': 'bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200'
            };
            return classes[type] || 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-200';
        },

        formatMigrationDate() {
            if (!this.configForm.migration_period_ends_at) {
                if (this.configForm.under_migration_days) {
                    return new Date(Date.now() + this.configForm.under_migration_days * 24 * 60 * 60 * 1000).toLocaleDateString('pt-BR', {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric'
                    });
                }
                return '-';
            }

            const parsedDate = parseBrazilianDate(this.configForm.migration_period_ends_at);
            if (!parsedDate) return '-';

            return parsedDate.toLocaleDateString('pt-BR', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            });
        },
    },
};
</script>
